module.exports = __webpack_public_path__ + "static/media/ecolab.a8c302ba.png";